<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="producedProducts"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
    :hasTableTitle="true"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :planningOperation="planningOperation"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :planningOperation="planningOperation"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :planningOperation="planningOperation"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: ,
      maskFields: [
        { field: 'expectedUnitPrice', mask: 'currency_10d' },
        { field: 'price', mask: 'currency'},
        { field: 'quantity', mask: 'number' }
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    producedProducts: { 
      type: Array,
      default: () => []
    },
    planningOperation: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    objectType: {
      type: String,
      default: "ProducedProduct"
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Produto Produzido"
    },
    modelNamePlural: {
      type: String,
      default: "Produtos Produzidos"
    },
  },
  created() {
  },
  computed: {
    tableHeaders: function() {
      return [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "Depósito", align: "left", sortable: true, value: "storage.name" },
        { text: "Quantidade", align: "left", sortable: true, value: "quantity" },
        { text: "Und.", align: "left", sortable: true, value: "item.unit.name" },
        { text: "R$ Est. Venda", align: "left", sortable: true, value: "expectedUnitPrice" },
        { text: "R$ Total Venda", align: "left", sortable: true, value: "price" },
        ... !this.readOnly ? [{ text: "Ações", value: "action", sortable: false }] : []
      ]
    }
  },
  methods: {
    entryUpdated: function(editedEntry){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(editedEntry){
      this.producedProducts.push(editedEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(editedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};
</script>

<style scoped></style>
